/**
 * The words for a boolean "active" state, wherever it is shown or set: TwnIndicator's default text in a
 * table's Active column, and the options of a bulk "Active State" field. One place, so the two never drift.
 */
const ACTIVE_STATE_LABELS = {
  active: 'Active',
  inactive: 'Inactive'
} as const

const activeStateLabel = (isActive: boolean): string =>
  isActive ? ACTIVE_STATE_LABELS.active : ACTIVE_STATE_LABELS.inactive

/**
 * The options for a field that sets the state. Built from `activeStateLabel`, not from
 * `Object.entries(ACTIVE_STATE_LABELS)` as an enum's options are: the value must stay a real boolean,
 * where `Object.entries` would hand the backend the strings `'true'` and `'false'`.
 */
const ACTIVE_STATE_OPTIONS = [true, false].map(value => ({ label: activeStateLabel(value), value }))

export { ACTIVE_STATE_LABELS, ACTIVE_STATE_OPTIONS, activeStateLabel }
